// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"_3swoGf3","table":"_3p1Bswi","toggleCell":"_1678pIM","toggleGroup":"_2-JxcV0","toggle":"_1bE9mqu"};